function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { compact } from 'lodash-es';
import { PracticeManagement } from "../types/api.model";
export let ServiceIntegrationType = /*#__PURE__*/function (ServiceIntegrationType) {
  ServiceIntegrationType["Qbo"] = "qbo";
  ServiceIntegrationType["Karbon"] = "karbon";
  ServiceIntegrationType["ClientHub"] = "clientHub";
  ServiceIntegrationType["FinancialCents"] = "financialCents";
  ServiceIntegrationType["Keeper"] = "keeper";
  ServiceIntegrationType["Xero"] = "xero";
  return ServiceIntegrationType;
}({});
export let IntegratedClassType = /*#__PURE__*/function (IntegratedClassType) {
  IntegratedClassType["Set"] = "set";
  IntegratedClassType["Unset"] = "unset";
  return IntegratedClassType;
}({});
export let AssignedUserType = /*#__PURE__*/function (AssignedUserType) {
  AssignedUserType["Assigned"] = "assigned";
  AssignedUserType["Unassigned"] = "unassigned";
  return AssignedUserType;
}({});
const hasAssignedMembers = teamMembers => Object.values(teamMembers).some(member => (member === null || member === void 0 ? void 0 : member.type) === AssignedUserType.Assigned);
export class ServiceIntegrationsModel {
  static fromDTO(serviceIntegrations) {
    if (!serviceIntegrations) return new ServiceIntegrationsModel({});
    let qbo = undefined;
    let xero = undefined;
    let karbon = undefined;
    let clientHub = undefined;
    let financialCents = undefined;
    let keeper = undefined;
    serviceIntegrations.forEach(integration => {
      if (integration.type === ServiceIntegrationType.Qbo) {
        qbo = QboServiceIntegrationModel.fromDTO(integration);
      } else if (integration.type === ServiceIntegrationType.Xero) {
        xero = XeroServiceIntegrationModel.fromDTO(integration);
      } else if (integration.type === ServiceIntegrationType.FinancialCents) {
        financialCents = PracticeManagementServiceIntegrationModel.fromDTO(integration);
      } else if (integration.type === ServiceIntegrationType.Karbon) {
        karbon = PracticeManagementServiceIntegrationModel.fromDTO(integration);
      } else if (integration.type === ServiceIntegrationType.ClientHub) {
        clientHub = PracticeManagementServiceIntegrationModel.fromDTO(integration);
      } else if (integration.type === ServiceIntegrationType.Keeper) {
        keeper = PracticeManagementServiceIntegrationModel.fromDTO(integration);
      }
    });
    return new ServiceIntegrationsModel({
      qbo,
      financialCents,
      karbon,
      clientHub,
      keeper,
      xero
    });
  }
  constructor(data) {
    this.qbo = data.qbo;
    this.karbon = data.karbon;
    this.clientHub = data.clientHub;
    this.financialCents = data.financialCents;
    this.keeper = data.keeper;
    this.xero = data.xero;
  }
  toJSON() {
    var _this$qbo, _this$karbon, _this$clientHub, _this$financialCents, _this$keeper, _this$xero;
    const json = compact([(_this$qbo = this.qbo) === null || _this$qbo === void 0 ? void 0 : _this$qbo.toJSON(), (_this$karbon = this.karbon) === null || _this$karbon === void 0 ? void 0 : _this$karbon.toJSON(), (_this$clientHub = this.clientHub) === null || _this$clientHub === void 0 ? void 0 : _this$clientHub.toJSON(), (_this$financialCents = this.financialCents) === null || _this$financialCents === void 0 ? void 0 : _this$financialCents.toJSON(), (_this$keeper = this.keeper) === null || _this$keeper === void 0 ? void 0 : _this$keeper.toJSON(), (_this$xero = this.xero) === null || _this$xero === void 0 ? void 0 : _this$xero.toJSON()]);
    return json.length ? json : undefined;
  }
  hasIntegrations() {
    return !!(this.qbo || this.financialCents || this.karbon || this.clientHub || this.keeper || this.xero);
  }
  xeroIntegratedId() {
    var _this$xero2;
    return ((_this$xero2 = this.xero) === null || _this$xero2 === void 0 ? void 0 : _this$xero2.integratedId()) || undefined;
  }
  qboIntegratedId() {
    var _this$qbo2;
    return ((_this$qbo2 = this.qbo) === null || _this$qbo2 === void 0 ? void 0 : _this$qbo2.integratedId()) || undefined;
  }
  qboIntegratedClassId() {
    return this.qbo ? this.qbo.integratedClassId() : null;
  }
  isQboClassSet() {
    var _this$qbo$hasQboClass, _this$qbo3;
    return (_this$qbo$hasQboClass = (_this$qbo3 = this.qbo) === null || _this$qbo3 === void 0 ? void 0 : _this$qbo3.hasQboClassId()) !== null && _this$qbo$hasQboClass !== void 0 ? _this$qbo$hasQboClass : false;
  }
  qboIntegratedType() {
    var _this$qbo4;
    return ((_this$qbo4 = this.qbo) === null || _this$qbo4 === void 0 ? void 0 : _this$qbo4.integratedType()) || undefined;
  }
  financialCentsIntegration() {
    return this.financialCents;
  }
  karbonIntegration() {
    return this.karbon;
  }
  clientHubIntegration() {
    return this.clientHub;
  }
  keeperIntegration() {
    return this.keeper;
  }
  financialCentsIntegratedIds() {
    var _this$financialCents2;
    return ((_this$financialCents2 = this.financialCents) === null || _this$financialCents2 === void 0 ? void 0 : _this$financialCents2.getIntegratedIds()) || [];
  }
  karbonIntegratedIds() {
    var _this$karbon2;
    return ((_this$karbon2 = this.karbon) === null || _this$karbon2 === void 0 ? void 0 : _this$karbon2.getIntegratedIds()) || [];
  }
  clientHubIntegratedIds() {
    var _this$clientHub2;
    return ((_this$clientHub2 = this.clientHub) === null || _this$clientHub2 === void 0 ? void 0 : _this$clientHub2.getIntegratedIds()) || [];
  }
  keeperIntegratedIds() {
    var _this$keeper2;
    return ((_this$keeper2 = this.keeper) === null || _this$keeper2 === void 0 ? void 0 : _this$keeper2.getIntegratedIds()) || [];
  }
  setInnerIntegration(integrationKey, params, _ref) {
    var _this$integrationKey$, _this$integrationKey, _this$integrationKey$2, _this$integrationKey2, _this$integrationKey$3, _this$integrationKey3, _params$integratedIds;
    let {
      preserveExistingTeamMembers: assignTeamMembers
    } = _ref;
    const existingTeamMembers = (_this$integrationKey$ = (_this$integrationKey = this[integrationKey]) === null || _this$integrationKey === void 0 ? void 0 : _this$integrationKey.getTeamMembers()) !== null && _this$integrationKey$ !== void 0 ? _this$integrationKey$ : {};
    const existingIntegratedIds = (_this$integrationKey$2 = (_this$integrationKey2 = this[integrationKey]) === null || _this$integrationKey2 === void 0 ? void 0 : _this$integrationKey2.getIntegratedIds()) !== null && _this$integrationKey$2 !== void 0 ? _this$integrationKey$2 : [];
    const existingEnabled = (_this$integrationKey$3 = (_this$integrationKey3 = this[integrationKey]) === null || _this$integrationKey3 === void 0 ? void 0 : _this$integrationKey3.isEnabled()) !== null && _this$integrationKey$3 !== void 0 ? _this$integrationKey$3 : false;
    const newTeamMembers = params === null || params === void 0 ? void 0 : params.teamMembers;
    const newIntegration = new PracticeManagementServiceIntegrationModel(integrationKey, (_params$integratedIds = params === null || params === void 0 ? void 0 : params.integratedIds) !== null && _params$integratedIds !== void 0 ? _params$integratedIds : existingIntegratedIds, assignTeamMembers && newTeamMembers ? _objectSpread(_objectSpread({}, existingTeamMembers), newTeamMembers) : newTeamMembers !== null && newTeamMembers !== void 0 ? newTeamMembers : existingTeamMembers, (params === null || params === void 0 ? void 0 : params.enabled) !== undefined ? params.enabled : existingEnabled);
    return this.cloneWithChanges({
      [integrationKey]: newIntegration
    });
  }
  setFinancialCentsIntegration(financialCents) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return this.setInnerIntegration(ServiceIntegrationType.FinancialCents, financialCents, options);
  }
  setKarbonIntegration(karbon) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return this.setInnerIntegration(ServiceIntegrationType.Karbon, karbon, options);
  }
  setKeeperIntegration(keeper) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return this.setInnerIntegration(ServiceIntegrationType.Keeper, keeper, options);
  }
  setClientHubIntegration(clientHub) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return this.setInnerIntegration(ServiceIntegrationType.ClientHub, clientHub, options);
  }
  setQboIntegration(qbo) {
    return this.cloneWithChanges({
      qbo
    });
  }
  setXeroIntegration(xero) {
    return this.cloneWithChanges({
      xero
    });
  }
  setFinancialCentsIntegratedIds(integratedIds) {
    const financialCents = this.financialCents ? this.financialCents.setIntegratedIds(integratedIds) : integratedIds.length ? PracticeManagementServiceIntegrationModel.makeFinancialCents({
      integratedIds
    }) : undefined;
    return this.cloneWithChanges({
      financialCents
    });
  }
  setKarbonIntegratedIds(integratedIds) {
    const karbon = this.karbon ? this.karbon.setIntegratedIds(integratedIds) : integratedIds.length ? PracticeManagementServiceIntegrationModel.makeKarbon({
      integratedIds
    }) : undefined;
    return this.cloneWithChanges({
      karbon
    });
  }
  setClientHubIntegratedIds(integratedIds) {
    const clientHub = this.clientHub ? this.clientHub.setIntegratedIds(integratedIds) : integratedIds.length ? PracticeManagementServiceIntegrationModel.makeClientHub({
      integratedIds
    }) : undefined;
    return this.cloneWithChanges({
      clientHub
    });
  }
  setKeeperIntegratedIds(integratedIds) {
    const keeper = this.keeper ? this.keeper.setIntegratedIds(integratedIds) : integratedIds.length ? PracticeManagementServiceIntegrationModel.makeKeeper({
      integratedIds
    }) : undefined;
    return this.cloneWithChanges({
      keeper
    });
  }
  setQboIntegratedClass(integratedClass) {
    if (this.qbo) {
      return this.cloneWithChanges({
        qbo: this.qbo.setIntegratedClass(integratedClass)
      });
    }
    if (integratedClass != null) {
      return this.cloneWithChanges({
        qbo: new QboServiceIntegrationModel(null, integratedClass.type === IntegratedClassType.Set ? integratedClass.set.id : null, undefined)
      });
    }
    return this.cloneWithChanges({
      qbo: undefined
    });
  }
  setXeroIntegratedId(integratedId) {
    const xero = this.xero ? this.xero.setIntegratedId(integratedId) : integratedId != null ? new XeroServiceIntegrationModel(integratedId) : undefined;
    return this.cloneWithChanges({
      xero
    });
  }
  setQboIntegratedId(integratedId) {
    const qbo = this.qbo ? this.qbo.setIntegratedId(integratedId) : integratedId != null ? new QboServiceIntegrationModel(integratedId, null, undefined) : undefined;
    return this.cloneWithChanges({
      qbo
    });
  }
  setQboIntegratedType(type) {
    const qbo = this.qbo ? this.qbo.setIntegratedType(type) : type != null ? new QboServiceIntegrationModel(null, null, type) : undefined;
    return this.cloneWithChanges({
      qbo
    });
  }
  cloneWithChanges() {
    let changes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new ServiceIntegrationsModel({
      qbo: 'qbo' in changes ? changes.qbo : this.qbo,
      karbon: 'karbon' in changes ? changes.karbon : this.karbon,
      clientHub: 'clientHub' in changes ? changes.clientHub : this.clientHub,
      financialCents: 'financialCents' in changes ? changes.financialCents : this.financialCents,
      keeper: 'keeper' in changes ? changes.keeper : this.keeper,
      xero: 'xero' in changes ? changes.xero : this.xero
    });
  }
}
export class XeroServiceIntegrationModel {
  static fromDTO(dto) {
    return new XeroServiceIntegrationModel(dto.value.integratedId);
  }
  constructor(_integratedId) {
    this._integratedId = _integratedId;
  }
  toJSON() {
    return {
      type: ServiceIntegrationType.Xero,
      value: {
        integratedId: this._integratedId
      }
    };
  }
  integratedId() {
    return this._integratedId;
  }
  setIntegratedId(integratedId) {
    return new XeroServiceIntegrationModel(integratedId || null);
  }
}
export class QboServiceIntegrationModel {
  static fromDTO(dto) {
    var _dto$value$integrated;
    const integratedClassId = ((_dto$value$integrated = dto.value.integratedClass) === null || _dto$value$integrated === void 0 ? void 0 : _dto$value$integrated.type) === IntegratedClassType.Set ? dto.value.integratedClass.set.id : null;
    return new QboServiceIntegrationModel(dto.value.integratedId, integratedClassId, dto.value.type);
  }
  constructor(_integratedId, _integratedClassId, _type) {
    this._integratedId = _integratedId;
    this._integratedClassId = _integratedClassId;
    this._type = _type;
  }
  toJSON() {
    return {
      type: ServiceIntegrationType.Qbo,
      value: {
        integratedId: this._integratedId,
        type: this._type,
        integratedClass: this._integratedClassId != null ? {
          type: IntegratedClassType.Set,
          set: {
            id: this._integratedClassId
          }
        } : {
          type: IntegratedClassType.Unset
        }
      }
    };
  }
  integratedId() {
    return this._integratedId;
  }
  integratedClassId() {
    return this._integratedClassId;
  }
  hasQboClassId() {
    return this._integratedClassId != null;
  }
  integratedType() {
    return this._type;
  }
  setIntegratedClass(integratedClass) {
    const integratedClassId = (integratedClass === null || integratedClass === void 0 ? void 0 : integratedClass.type) === IntegratedClassType.Set ? integratedClass.set.id : null;
    return new QboServiceIntegrationModel(this._integratedId, integratedClassId, this._type);
  }
  setIntegratedId(integratedId) {
    return new QboServiceIntegrationModel(integratedId || null, this._integratedClassId, this._type);
  }
  setIntegratedType(type) {
    return new QboServiceIntegrationModel(this._integratedId, this._integratedClassId, type);
  }
}
export class PracticeManagementServiceIntegrationModel {
  static fromDTO(pm) {
    var _pm$value$enabled;
    const teamMembers = pm.value.teamMembers || {};
    const enabled = (_pm$value$enabled = pm.value.enabled) !== null && _pm$value$enabled !== void 0 ? _pm$value$enabled : hasAssignedMembers(teamMembers);
    return new PracticeManagementServiceIntegrationModel(pm.type, pm.value.integratedIds, teamMembers, enabled);
  }
  static makeFinancialCents(_ref2) {
    let {
      integratedIds = null,
      teamMembers = {},
      enabled
    } = _ref2;
    const resolvedEnabled = typeof enabled === 'boolean' ? enabled : hasAssignedMembers(teamMembers);
    return new PracticeManagementServiceIntegrationModel(ServiceIntegrationType.FinancialCents, integratedIds, teamMembers, resolvedEnabled);
  }
  static makeKarbon(_ref3) {
    let {
      teamMembers = {},
      integratedIds = null,
      enabled
    } = _ref3;
    const resolvedEnabled = typeof enabled === 'boolean' ? enabled : hasAssignedMembers(teamMembers);
    return new PracticeManagementServiceIntegrationModel(ServiceIntegrationType.Karbon, integratedIds, teamMembers, resolvedEnabled);
  }
  static makeClientHub(_ref4) {
    let {
      teamMembers = {},
      integratedIds = null,
      enabled
    } = _ref4;
    const resolvedEnabled = typeof enabled === 'boolean' ? enabled : hasAssignedMembers(teamMembers);
    return new PracticeManagementServiceIntegrationModel(ServiceIntegrationType.ClientHub, integratedIds, teamMembers, resolvedEnabled);
  }
  static makeKeeper(_ref5) {
    let {
      teamMembers = {},
      integratedIds = null,
      enabled
    } = _ref5;
    const resolvedEnabled = typeof enabled === 'boolean' ? enabled : hasAssignedMembers(teamMembers);
    return new PracticeManagementServiceIntegrationModel(ServiceIntegrationType.Keeper, integratedIds, teamMembers, resolvedEnabled);
  }
  constructor(type, integratedIds, teamMembers, enabled) {
    this.type = type;
    this.integratedIds = integratedIds;
    this.teamMembers = teamMembers;
    this.enabled = enabled;
  }
  toJSON() {
    return {
      type: this.type,
      value: {
        integratedIds: this.integratedIds,
        teamMembers: this.teamMembers
      }
    };
  }
  getIntegratedIds() {
    return this.integratedIds;
  }
  getTeamMembers() {
    return this.teamMembers;
  }
  getType() {
    return this.type;
  }
  accept(visitor) {
    switch (this.type) {
      case ServiceIntegrationType.FinancialCents:
        return visitor.visitFinancialCents(this);
      case ServiceIntegrationType.Karbon:
        return visitor.visitKarbon(this);
      case ServiceIntegrationType.ClientHub:
        return visitor.visitClientHub(this);
      case ServiceIntegrationType.Keeper:
        return visitor.visitKeeper(this);
    }
  }
  isEnabled() {
    return this.enabled;
  }
  hasAssignedTeamMembers() {
    return hasAssignedMembers(this.teamMembers);
  }
  assignTeamMember(roleId, userId) {
    const newTeamMembers = _objectSpread(_objectSpread({}, this.teamMembers), {}, {
      [roleId]: userId ? makeAssignedUserAssigned(userId) : makeAssignedUserUnassigned()
    });
    return this.cloneWithChanges({
      teamMembers: newTeamMembers
    });
  }
  assignedUserId(roleId) {
    const byRoleId = this.teamMembers[roleId];
    return byRoleId && byRoleId.type === AssignedUserType.Assigned ? byRoleId.assigned : null;
  }
  setIntegratedIds(integratedIds) {
    return this.cloneWithChanges({
      integratedIds
    });
  }
  practiceManagementType() {
    return Object.keys(PracticeManagementServiceIntegrationModel.TYPE_MAP).includes(this.type) ? PracticeManagementServiceIntegrationModel.TYPE_MAP[this.type] : null;
  }
  cloneWithChanges() {
    var _changes$enabled;
    let changes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new PracticeManagementServiceIntegrationModel(this.type, changes.integratedIds || this.integratedIds, changes.teamMembers || this.teamMembers, (_changes$enabled = changes.enabled) !== null && _changes$enabled !== void 0 ? _changes$enabled : this.enabled);
  }
}
_defineProperty(PracticeManagementServiceIntegrationModel, "TYPE_MAP", {
  [ServiceIntegrationType.FinancialCents]: PracticeManagement.FinancialCents,
  [ServiceIntegrationType.Karbon]: PracticeManagement.Karbon,
  [ServiceIntegrationType.ClientHub]: PracticeManagement.ClientHub,
  [ServiceIntegrationType.Keeper]: PracticeManagement.Keeper
});
export function makeAssignedUserUnassigned() {
  return {
    type: AssignedUserType.Unassigned
  };
}
export function makeAssignedUserAssigned(assigned) {
  return {
    type: AssignedUserType.Assigned,
    assigned
  };
}